import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaRuleResponse } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";
import type { CreateLeaderCriteriaRuleModel } from "~pages/LeaderCriteria/types/leaderCriteriaRuleModel.ts";

export const useCreateLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<LeaderCriteriaRuleResponse, Error, CreateLeaderCriteriaRuleModel>({
    mutationFn: async (body) =>
      await request<LeaderCriteriaRuleResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
